import { ILegalTeamManagement } from "../../models/LegalTeamManagment";

export interface legalTeamData {
    branch?: string,
    branch_ID?: number,
    company?: string,
    company_ID?: number,
    team_ID?: number,
    team_Manager?: string,
    team_Manager_ID?: number,
    team_Name?: string
}

export const EmptyLegalTeam: ILegalTeamManagement = {
    Team_ID: 0,
    Team_Name: "",
    Status: true,
    User_Added_by: 0,
    CreatedOn: new Date(),
    TeamManagerid: 0,
    Company_Name: 0,
    Branch_Name: 0
};

export const LegalTeamData: legalTeamData = {
    branch: "",
    branch_ID: 0,
    company: "",
    company_ID: 0,
    team_ID: 0,
    team_Manager: "",
    team_Manager_ID: 0,
    team_Name: ""
};

